import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


export interface SliceDragCloseEvent {
  pieceId: string;
  sliceId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SliceDragEventsService {

  public readonly closeSliceSubject = new Subject<SliceDragCloseEvent>();
  public closeSlice$ = this.closeSliceSubject.asObservable();


  public emitCloseSlice(event: SliceDragCloseEvent): void {
    this.closeSliceSubject.next(event);
  }

}
